import { inject } from '@angular/core'
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router'
import { getDisableGeneralChatFromStorage } from '@utils/storage.utils'

export const chatRouteGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router)

  const hasChatParam = route.queryParams['chat']

  const isDisabled = getDisableGeneralChatFromStorage()

  if (isDisabled && !hasChatParam) {
    router.navigate(['/dashboard/media-library'])
    return false
  }

  return true
}
